import { Component } from '@angular/core';

@Component({
	selector: 'invoice-payment-schedule',
	template: require('./invoice-payment-schedule.html'),
	styles: [require('./invoice-payment-schedule.scss')]
})
export class InvoicePaymentScheduleComponent {
	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/invoices/invoice-update/invoice-payment-schedule/invoice-payment-schedule.ts